<template>
  <v-container
    class="d-flex justify-center align-center flex-column"
    style="height: 80vh"
  >
    <section v-if="vrifyRet">
      <section v-if="vrifyRet.status === 200">
        <router-link to="/">
          <img
            width="350"
            height="auto"
            :src="require('@/assets/images/logos/logo.png')"
          />
        </router-link>
        <v-card
          :loading="submitting"
          :disabled="submitting"
          class="mx-auto my-5"
          width="500"
          outlined
        >
          <div class="ma-5">
            <section v-if="resetRet && resetRet.status === 200">
              <p class="text-subtitle-1 success--text">You have successfully completed the password change.</p>
            </section>
            <section v-else>
              <v-alert outlined type="error" v-if="resetRet">
                <span v-html="resetRet.data"></span>
              </v-alert>
              <v-form
                ref="form"
                @submit.prevent="submitResetPassword"
              >
                <v-text-field
                  v-model="vrifyRet.data.userName"
                  label="UserName"
                  outlined
                  disabled
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="newPassword"
                  dense
                  outlined
                  label="New password"
                  :rules="[required, min6]"
                  :append-icon="passwordVisiable ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="passwordVisiable ? 'text' : 'password'"
                  @click:append="passwordVisiable = !passwordVisiable"
                ></v-text-field>
                <v-text-field
                  v-model="newPassword2"
                  label="Confirm new password"
                  dense
                  outlined
                  :rules="[
                    (v) => !!v || 'This field is required.',
                    (v) => (v && v.length > 6) || 'Please enter at least 6 digits.',
                    (v) => v === this.newPassword || `Passwords don't match`
                  ]"
                  :append-icon="passwordVisiable ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="passwordVisiable ? 'text' : 'password'"
                  @click:append="passwordVisiable = !passwordVisiable"
                  ></v-text-field>
                <v-btn color="primary" type="submit" class="my-5 text-none" block>
                  Change Password
                </v-btn>
              </v-form>
            </section>
            <v-divider class="my-3"></v-divider>
            <div class="text-center mx-auto">
              <router-link to="/sign-in" class="text-decoration-none text-center">
                Return to sign in
              </router-link>
            </div>
          </div>
        </v-card>
      </section>
      <section v-else>
        <div class="error--text">{{ vrifyRet.data }}</div>
      </section>
    </section>
    <section v-else>
      Authenticating....
    </section>
  </v-container>
</template>

<script>
import { rules } from "@/mixins";

export default {
  name: "ResetPassword",
  async mounted(){
    this.vrifyRet = await this.$store
        .dispatch("authentication/verifyRecoveryLink", {
          userId: this.$route.query.userId,
          guid: this.$route.query.guid
        })
        .then((resp) => resp)
        .catch((err) => err);
  },
  data() {
    return {
      vrifyRet: null,
      resetRet: null,
      newPassword: null,
      newPassword2: null,
      passwordVisiable: false,
      submitting: false,
    };
  },
  methods: {
    async submitResetPassword(){
      if (this.$refs.form.validate()) {
        this.submitting = true;

        this.resetRet = await this.$store
          .dispatch("authentication/resetPassword", {
            userId: this.$route.query.userId,
            guid: this.$route.query.guid,
            newPassword : this.newPassword
          })
          .then((resp) => resp)
          .catch((err) => err);

        this.submitting = false;
      }
    },
  },
  mixins: [rules],
};
</script>
